// extracted by mini-css-extract-plugin
export default {"imageContainer":"ImageCell_imageContainer__OOo8Z"};